export default "__VITE_ASSET__DH6go5IL__"